import { useState, useEffect } from "react"

export const useIsPortrait = (): boolean => {
  const [isPortrait, setIsPortrait] = useState<boolean>(() => {
    if (typeof window !== "undefined") {
      return window.matchMedia("(orientation: portrait)").matches
    }
    return false
  })

  useEffect(() => {
    if (typeof window === "undefined") return
    const mediaQuery = window.matchMedia("(orientation: portrait)")
    const handleChange = (e: MediaQueryListEvent) => {
      setIsPortrait(e.matches)
    }
    mediaQuery.addEventListener("change", handleChange)
    return () => {
      mediaQuery.removeEventListener("change", handleChange)
    }
  }, [])

  return isPortrait
}
